import { render, staticRenderFns } from "./HeaderMobileBackButton.vue?vue&type=template&id=729fe0b2"
import script from "./HeaderMobileBackButton.vue?vue&type=script&lang=js"
export * from "./HeaderMobileBackButton.vue?vue&type=script&lang=js"
import style0 from "./HeaderMobileBackButton.vue?vue&type=style&index=0&id=729fe0b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports